// Mini-map panel — Canvas2D rendering of the zone graph + player position.
// Mounted top-right of the screen. Updates on zone_map and on every room change.

import type { ClientState, ClientStore, ZoneMap } from "../state.js";

export function mountMinimap(host: HTMLElement, store: ClientStore): void {
  host.innerHTML = `
    <div class="minimap-card">
      <div class="minimap-title" id="mm-title"></div>
      <canvas id="mm-canvas" width="180" height="180"></canvas>
    </div>
  `;
  const title  = host.querySelector<HTMLElement>("#mm-title")!;
  const canvas = host.querySelector<HTMLCanvasElement>("#mm-canvas")!;
  const ctx    = canvas.getContext("2d")!;

  function repaint(state: ClientState): void {
    const map = state.zone_map;
    if (!map) {
      title.textContent = "";
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      return;
    }
    title.textContent = map.zone_name;
    drawMap(ctx, canvas.width, canvas.height, map, state.room?.room ?? null);
  }
  store.subscribe(repaint);
  repaint(store.get());
}

function drawMap(ctx: CanvasRenderingContext2D, w: number, h: number, map: ZoneMap, current: string | null): void {
  ctx.clearRect(0, 0, w, h);
  const pad = 14;
  const innerW = w - pad * 2;
  const innerH = h - pad * 2;
  const xy = new Map<string, [number, number]>();
  for (const r of map.rooms) {
    xy.set(r.id, [pad + r.x * innerW, pad + r.y * innerH]);
  }
  // Edges
  ctx.strokeStyle = "#3a4258";
  ctx.lineWidth = 1.2;
  for (const e of map.edges) {
    const a = xy.get(e.from); const b = xy.get(e.to);
    if (!a || !b) continue;
    ctx.beginPath();
    ctx.moveTo(a[0], a[1]);
    ctx.lineTo(b[0], b[1]);
    ctx.stroke();
  }
  // Rooms
  for (const r of map.rooms) {
    const c = xy.get(r.id)!;
    const isCurrent = r.id === current;
    ctx.fillStyle = isCurrent ? "#d9b150" : "#1a1d26";
    ctx.strokeStyle = isCurrent ? "#fff7e0" : "#5a6478";
    ctx.lineWidth = isCurrent ? 2 : 1;
    ctx.beginPath();
    ctx.arc(c[0], c[1], isCurrent ? 6 : 4, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();
  }
}
